import { Grid } from '@mui/material';
import CustomBreadCrumbs from 'components/CustomBreadCrumbs';
import { useLoadingDocumentsPage } from 'hooks/useLoadingDocumentsPage';
import DocumentsTable from '../components/DocumentsTable';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { setDocument } from 'slices/documentSlice';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { useDocumentsNavigateTo } from '../../../hooks/useDocumentsNavigateTo';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useFetchDocumentsPage } from 'hooks/useFetchDocumentsPage';

const SharedDocumentsPage = () => {
    const dispatch = useAppDispatch();
    const { openModal: openDocumentMarkupModal } = useModal();
    const [searchParams] = useSearchParams();
    const documentId = searchParams.get('document');
    const { navigateTo } = useDocumentsNavigateTo('shared');
    const { listDocuments, breadcrumbs } = useAppSelector((state) => state.documents);
    const loading = useLoadingDocumentsPage({ mode: 'shared' }); // Pass true to indicate shared documents { isShared: true }
    const { fetchData } = useFetchDocumentsPage('shared');

    useEffect(() => {
        if (documentId && listDocuments.length > 0) {
            const document = listDocuments.find((item: Document) => item.id === documentId);
            if (document) {
                dispatch(setDocument(document));
                openDocumentMarkupModal('documentMarkupModal', {}, {
                    onSubmit: () => {
                        fetchData();
                    }
                });
            }
        }
    }, [documentId, listDocuments]);

    return (
        <>
            <Grid item xs={8} sx={{ pt: 2, pb: 3 }}>
                <CustomBreadCrumbs
                    title="Shared Documents"
                    loading={loading}
                    breadcrumbs={breadcrumbs}
                    onRootClick={() => {
                        navigateTo();
                    }}
                    onClick={(breadcrumb) => {
                        navigateTo(breadcrumb.id);
                    }}
                />
            </Grid>
            <DndProvider backend={HTML5Backend}>
                {/* Only allow view only on shared documents */}
                <DocumentsTable
                    modeDocument={'shared'}
                    filterActions={(actions) => {
                        return actions.filter((action) => action.key === 'Download');
                    }}
                />
            </DndProvider>
        </>
    );
};

export default SharedDocumentsPage;
